var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.405 19.599 6.62 15.38a8.398 8.398 0 0 1-1.588-4.922 8.4 8.4 0 0 1 2.479-5.98A8.402 8.402 0 0 1 13.492 2c2.26 0 4.385.88 5.982 2.479a8.402 8.402 0 0 1 2.478 5.98c0 2.26-.88 4.384-2.478 5.982a8.405 8.405 0 0 1-5.981 2.479 8.381 8.381 0 0 1-4.921-1.588l-4.217 4.217a1.375 1.375 0 0 1-1.95 0 1.379 1.379 0 0 1 0-1.95zm15.118-5.109a5.665 5.665 0 0 0 1.67-4.031 5.662 5.662 0 0 0-1.67-4.03 5.66 5.66 0 0 0-4.03-1.671 5.662 5.662 0 0 0-4.031 1.67 5.664 5.664 0 0 0-1.67 4.031c0 1.522.592 2.954 1.67 4.032a5.66 5.66 0 0 0 4.03 1.669 5.659 5.659 0 0 0 4.031-1.67z",
    fill: "#636363"
  })));
};

export default SvgIconSearch;